/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DoctorSpecialtyType {
  MAIN = 'MAIN',
  WORK_AREA = 'WORK_AREA',
}
